import is from 'is_js';
import React, { useRef } from 'react';
import { createUseStyles } from 'react-jss';
import { useShake } from '../../hooks/use-shake';
import { layoutDefaults } from '../../utils/layout-defaults';
import { publicResources } from '../../utils/public-resources';

function DownloadButtons({ onAppDownloadClick, shakeEnabled = true }) {
  const classes = useStyles();
  const buttonRef = useRef();

  useShake({
    element: buttonRef?.current,
    enabled: shakeEnabled,
  });

  return (
    <div className={classes.container}>
      {is.ios() && (
        <img
          ref={buttonRef}
          src={publicResources.image.downloadAppStore}
          alt=""
          className={classes.logo}
          onClick={() => onAppDownloadClick('ios')}
          aria-hidden="true"
        />
      )}
      <img
        ref={is.ios() ? null : buttonRef}
        // ref={buttonRef}
        src={publicResources.image.downloadGooglePlay}
        alt=""
        className={classes.logo}
        onClick={() => onAppDownloadClick('android')}
        aria-hidden="true"
      />
      {!is.ios() && (
        <img
          src={publicResources.image.downloadAppStore}
          alt=""
          className={classes.logo}
          onClick={() => onAppDownloadClick('ios')}
          aria-hidden="true"
        />
      )}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    // width: '100%',

    // border: '1px solid red',
  },
  logo: {
    // flex: 1,
    maxHeight: 52,
    cursor: 'pointer',
    margin: layoutDefaults.smallestHorizontalMargin,
    // margin: layoutDefaults.biggerHorizontalMargin,
    border: `1px solid ${layoutDefaults.buttonBorder}`,
    borderRadius: 8,
  },
});

export { DownloadButtons };
